import { Component, Input, ViewEncapsulation } from '@angular/core';
import { AppConfigService } from 'src/app/Services/app-config.service';
import { ShoreexcursionsService } from 'src/app/Services/shoreexcursions.service';
//import { excursionDialogComponent } from '../excursion-dialog/excursion-dialog.component';

import * as moment from 'moment';
import { Time } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { UserData } from 'src/app/Models/employee-and-user-data';
import { cruiseContentEvtCodeFromSession } from 'src/app/utils/voyage-pms-code';
import { ItiCodesService } from 'src/app/Services/iti-codes.service';

type iticodeInfo = {
  evtCode: string; 
  llcitiCode: string; 
  llcltcUid: number; 
  llcuid: number;
  ltcName: string; 
  ltcUid: number;
  itiBegDate: Date;
  locallooptoday: boolean; 
  localloopfuture: boolean; 
}; 

type shoreexcursions = {
  Type: string;
  Name: string;
  Description: string;
  BegDate: Date;
  EndDate: Date;

  rebcode: string;
  rebuid: number;
  folioid: number;
  evtCode: string;
  GuestName: string;
  expander: boolean;
  deduper: boolean;
  priordateequal: boolean;
};

@Component({
  selector: 'app-shore-excursions',
  templateUrl: './shore-excursions.component.html',
  styleUrls: ['./shore-excursions.component.css'],
  providers: [ShoreexcursionsService],
  encapsulation: ViewEncapsulation.None,
})
export class ShoreExcursionsComponent {
  @Input() inputdate: string | undefined;
    
  CurrentDate: any;
  itiBegDate: any;

  userdata?: UserData;
  rebcode: string | undefined;
  OBPortalSvcURL = '';
  cruiseCode: string | undefined;

  evtCode: string | undefined;

  itiName: string | undefined; 
  ltcName: string | undefined; 

  iticodedata: any; 
  iticodes: iticodeInfo[] = [];

  shoreexcursionsInfo: shoreexcursions[] = [];
  shoreexcursiondata: any;
  asofdate: string | undefined;

  constructor(
    private appConfigService: AppConfigService,
    public dialog: MatDialog,
    private ShoreexcursionsService: ShoreexcursionsService,
    private ItiCodesService: ItiCodesService,
  ) {}

  ngOnInit() {
    this.OBPortalSvcURL = this.appConfigService.OBPortalSvcURL;
    this.userdata = JSON.parse(localStorage.getItem('userinfo') || '{}');
    this.rebcode = this.userdata?.rebcode;
    this.evtCode = cruiseContentEvtCodeFromSession(this.userdata);
    this.itiName = this.ltcName; 
    this.asofdate = moment().format('YYYY-MM-DD');
    this.CurrentDate = moment().startOf('day').toDate();
    this.getShoreExcursions();
  }
  datecompare(date1: Date, date2: Date) {
    if (date1.toString().substring(0, 10) == date2.toString().substring(0, 10))
      return true;
    else return false;
  }

  getShoreExcursions() {
    this.shoreexcursiondata = this.ShoreexcursionsService.getShoreExcursions(
      this.rebcode,
      undefined
    ).subscribe((shoreexcursiondata) =>
      this.setshoreexcursions(shoreexcursiondata)
    );
  }

  setshoreexcursions(resdata: any) {
    this.shoreexcursiondata = resdata;
    if (this.shoreexcursiondata.GetShoreExcursions.Result.Status == 'A') {
      this.shoreexcursionsInfo =
        this.shoreexcursiondata.GetShoreExcursions.ShoreExcursionsList;
      for (let i = 0; i < this.shoreexcursionsInfo?.length; i++) {
        if (
          i > 0 &&
          this.shoreexcursionsInfo[i].Name ==
            this.shoreexcursionsInfo[i - 1].Name
        ) {
          this.shoreexcursionsInfo[i - 1].GuestName +=
            ', ' + this.shoreexcursionsInfo[i].GuestName;
          this.shoreexcursionsInfo[i].deduper = true;
        }
        if (
          i > 1 &&
          this.shoreexcursionsInfo[i].Name ==
            this.shoreexcursionsInfo[i - 2].Name
        ) {
          this.shoreexcursionsInfo[i - 2].GuestName +=
            ', ' + this.shoreexcursionsInfo[i].GuestName;
        }
      }
      for (let i = 0; i < this.shoreexcursionsInfo?.length; i++) {
        if (this.shoreexcursionsInfo[i].deduper == true)
          this.shoreexcursionsInfo.splice(i, 1);
      }
      for (let i = 0; i < this.shoreexcursionsInfo?.length; i++) {
        if (
          i > 0 &&
          this.datecompare(
            this.shoreexcursionsInfo[i].BegDate,
            this.shoreexcursionsInfo[i - 1].BegDate
          )
        ) {
          this.shoreexcursionsInfo[i].priordateequal = true;
        } else if (i == 0) this.shoreexcursionsInfo[i].priordateequal = false;
      }
      this.getItiCodes(); 
    }
  }

  getItiCodes() {
    this.iticodedata = this.ItiCodesService.getItiCodes(
      this.evtCode
    ).subscribe((iticodedata) => this.setItiCodes(iticodedata));
  }
  setItiCodes(resdata: any) {
    this.iticodedata = resdata; 
    if (this.iticodedata.GetItiCodes.Result.Status == 'A') {
      this.iticodes = this.iticodedata.GetItiCodes.ItiCodesList.filter(
        
        // if the ltcName ("Newport Local Loop: Newport, RI | AM") has a space then a | in it
        (s: { ltcName: string }) =>
          (s.ltcName.includes(' |')
        )); 
        //  remove everything after the space and | 
        this.iticodes.forEach((currentValue, index) => {

        if (currentValue.ltcName.includes(' |'))
          currentValue.ltcName = currentValue.ltcName.split(' |')[0]

        currentValue.itiBegDate = moment(currentValue?.itiBegDate).startOf('day').toDate();
        
        if (moment(currentValue?.itiBegDate).isSame(this.CurrentDate,'day'))
            currentValue.locallooptoday = true;

        if (moment(currentValue?.itiBegDate).isAfter(this.CurrentDate,'day'))
          currentValue.localloopfuture = true;

        });
      }
    }



}
